import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  id: "hub-tab-container",
  "data-testid": "hub-to-hub-tab-container",
  class: "w-full h-full"
}
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "text-xl text-black-lp-200 font-bold px-6 py-1 mt-1" }
const _hoisted_4 = {
  class: "px-5 w-full border-b border-t border-gray-lp-2100 pb-2",
  style: {"padding-top":"8px","margin-top":"6px","height":"36px"}
}
const _hoisted_5 = {
  class: "flex flex-row items-center font-semibold gap-6  text-gray-lp-600",
  ref: "tab-link-container"
}
const _hoisted_6 = {
  id: "tab-content",
  class: "w-full h-full pb-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('hubToHub.menuTitle')), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createBlock(_Fragment, null, [
              (tab.permission)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: tab.name,
                    to: tab.path,
                    class: "px-4 h-5",
                    ref: tab.refName,
                    exactActiveClass: "text-red-lp-100",
                    activeClass: "text-red-lp-100",
                    style: {"line-height":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ], 512),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          _createVNode("div", {
            class: "absolute bottom-0 border border-red-lp-100 w-full transition-all",
            style: {
              height: '2px',
              width: _ctx.tabRect.width + 'px',
              left: _ctx.tabRect.left + 'px',
              top: _ctx.tabRect.top + 20 + 'px',
              zIndex: '-1'
            }
          }, null, 4)
        ]))
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_router_view)
    ])
  ]))
}